import Service from "../Service";
const resource = "TasPaymentProducer/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  //   detail(parameters, requestID) {
  //     return Service.post(resource + "detail", parameters, {
  //       params: { requestID },
  //     });
  //   },
};
